import styled from 'styled-components';

const RootContainer = styled.div`
  max-width:50rem;
  width:calc(100% - 4rem);
  margin: 0 auto;
`

export default RootContainer